<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form" v-loading="loading">
        <el-form ref="form" :model="form" :rules="rules" label-width="1.2rem">
          <el-form-item label="文件" prop="file">
            <upload-files2
              :fileType="['apk']"
              :limit="1"
              v-model="form.file"
            ></upload-files2>
          </el-form-item>
          <el-form-item label="版本" prop="apkVersion">
            <el-input
              style="width: 100%"
              v-model="form.apkVersion"
              clearable
              placeholder="请输入版本（例如：1.2.1）"
            />
          </el-form-item>
          <el-form-item label="检查更新版本" prop="checkVersion">
            <el-input
              style="width: 100%"
              v-model="form.checkVersion"
              clearable
              maxlength="8"
              placeholder="请输入8位更新版本号（例如：20261111）"
            />
          </el-form-item>
          <el-form-item label="版本描述信息" prop="remark">
            <el-input
              style="width: 100%"
              v-model="form.remark"
              type="textarea"
              rows="6"
              clearable
              maxlength="500"
              show-word-limit
              placeholder="请输入版本描述信息"
            />
          </el-form-item>
          <el-form-item label="是否强制更新" prop="forceUpdate">
            <el-switch
              v-model="form.forceUpdate"
              size="medium"
              active-color="#526BEC"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>
<script>
import { addInfo, detailInfo, editInfo } from "./api";
import DialogContainer from "@/components/Dialog.vue";
import UploadFiles2 from "@/components/UploadFiles2.vue";
import { validateNumber, validateNumber8 } from "@/utils/validate";
export default {
  name: "AddOrEdit",
  data() {
    return {
      loading: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "添加/编辑apk",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          this.timer = null;
          clearTimeout(this.timer);
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        apkVersion: "",
        checkVersion: "",
        file: [],
        fileId: "",
        forceUpdate: true,
        remark: "",
      },
      rules: {
        apkVersion: [{ required: true, message: "版本号不能为空" }],
        file: [{ required: true, message: "文件不能为空" }],
        checkVersion: [{ required: true, message: "代码版本不能为空" },{ validator: validateNumber8, trigger: "blur" }],
        forceUpdate: [{ required: true, message: "不能为空" }],
      },
    };
  },
  components: {
    UploadFiles2,
    DialogContainer,
  },
  methods: {
    init(row) {
      if (!!row) {
        this.form = Object.assign({}, { file: [] }, row);
        this.form.file.push({
          fileId: row.fileId,
          filename: row.filename,
        });
        this.dialogObj.title = "编辑apk";
      } else {
        this.dialogObj.title = "添加apk";
      }
      this.dialogObj.show = true;
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodName = "";
          if (this.form.apkId) {
            methodName = editInfo;
          } else {
            methodName = addInfo;
          }
          const par = {
            apkId: this.form.apkId,
            fileId: this.form.file[0].fileId,
            apkVersion: this.form.apkVersion,
            checkVersion: this.form.checkVersion,
            forceUpdate: this.form.forceUpdate,
            remark: this.form.remark,
          };
          methodName(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.apkId ? "编辑成功" : "保存成功"
                );
                this.$parent.handleAddOrEditSuccess(
                  this.form.apkId ? "edit" : "add"
                );
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.config-management {
  width: 100%;
  height: 92vh;
  background-color: #ffffff;
  padding-top: 0.4rem;
  padding-left: 0.4rem;
  box-sizing: border-box;
}
</style>
